export class TemplateReqVM {
        UserID: string
        DatabaseID:Number
        templateName: string
        folderName:string
        OrganizationID: Number
        TemplateID: Number
  documentFolderID: number
  folderID: number
  isPublic: boolean
  transactionID: number
  transacctionID: number
  OfficeID:any
  OfficeIDList:any;
}
